import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import { UserRole } from '../roles';

/**
 * AccountSettingsRouter Component
 *
 * Redirects users to their role-specific settings page:
 * - Trainee → /trainee/account-settings (Personal Account Settings)
 * - Admin → /admin/settings (Admin Settings - same as sidebar)
 * - Trainer → /trainer/account-settings (Trainer Account Settings)
 * - Super Admin → /superadmin/settings (Super Admin Settings - same as sidebar)
 */
const AccountSettingsRouter: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  useEffect(() => {
    if (!user) {
      console.log('⚠️ AccountSettingsRouter: No user found, redirecting to login');
      navigate('/login');
      return;
    }

    console.log('⚙️ AccountSettingsRouter: Current user role:', user?.role);

    // Redirect based on user role
    switch (user?.role) {
      case UserRole.TRAINEE:
        console.log('⚙️ AccountSettingsRouter: Redirecting to Trainee Account Settings');
        navigate('/trainee/account-settings', { replace: true });
        break;

      case UserRole.ADMIN:
        console.log('⚙️ AccountSettingsRouter: Redirecting to Admin Settings');
        navigate('/admin/settings', { replace: true });
        break;

      case UserRole.TRAINER:
        console.log('⚙️ AccountSettingsRouter: Redirecting to Trainer Account Settings');
        navigate('/trainer/account-settings', { replace: true });
        break;

      case UserRole.SUPER_ADMIN:
        console.log('⚙️ AccountSettingsRouter: Redirecting to Super Admin Settings');
        navigate('/superadmin/settings', { replace: true });
        break;

      default:
        console.log('⚠️ AccountSettingsRouter: Unknown role, redirecting to login');
        navigate('/login');
        break;
    }
  }, [user, navigate]);

  // Show loading state while redirecting
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'var(--color-background, #ffffff)',
      color: 'var(--color-text-primary, #1f2937)'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid #e5e7eb',
          borderTopColor: '#FEB901',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }} />
        <p style={{ fontSize: '14px' }}>Loading Account Settings...</p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default AccountSettingsRouter;
